"use client";
import * as React from "react";
const SvgWifiRound = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 12", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M.33 4.45a1.05 1.05 0 0 0 1.44.08 9.6 9.6 0 0 1 12.45-.01 1.07 1.07 0 0 0 1.46-.07 1.15 1.15 0 0 0-.08-1.67 11.8 11.8 0 0 0-15.2 0c-.5.41-.54 1.19-.07 1.67m5.99 6.15 1.13 1.17c.3.3.79.3 1.09 0l1.13-1.17a.8.8 0 0 0-.17-1.26c-.95-.5-2.07-.5-3.02 0a.8.8 0 0 0-.16 1.26M3.44 7.64c.37.4.97.43 1.4.1a5.3 5.3 0 0 1 6.3 0c.45.32 1.04.3 1.42-.1.47-.48.44-1.3-.1-1.68a7.5 7.5 0 0 0-8.93 0c-.53.4-.56 1.2-.1 1.68" }));
export {
  SvgWifiRound as default
};
